module.exports = __webpack_public_path__ + "static/media/06_Timeline_belvedere_central.5a9857b2.webp";